import { useAnalytics } from '@sloyd/analytics';
import { PageMobile } from '@sloyd/app-editor';
import { AnalyticsLog, DropArea, Form, Memory, Prompt, Resolution, Toast } from '@sloyd/ui';
import { isMobile } from 'shared-base';
import { NavBarContainer } from '../containers/NavBar.container';
import { TopBarContainer } from '../containers/TopBar.container';
import { useNavigationMethod } from '../sagas/saga.navigation';
import { Content, Wrapper } from './App.style';
import { AppRoutes } from './Routes';
import { allRoutes } from './allRoutes';

const env = import.meta.env;
const SHOW_ANALYTICS_LOG = false;

export type AppProps = {
  navbarWidth: number;
  callbacks: {
    onLogoClick: () => void;
    onNavigate: (path: string) => void;
    onAction: OnAction;
    toggleLogs: () => void;
  };
};

export const App = (props: AppProps) => {
  const { navbarWidth = 200, callbacks } = props;

  useNavigationMethod();
  useAnalytics(env.MODE);
  // useMouseMileage(50 * 1000);

  const contentStyle = {
    marginLeft: isMobile() ? 0 : navbarWidth + 'px',
  };

  if (isMobile()) {
    return <PageMobile />;
  }

  return (
    <Wrapper>
      <TopBarContainer callbacks={callbacks} />
      <NavBarContainer callbacks={callbacks} />
      <Content style={contentStyle}>
        <AppRoutes routes={allRoutes} isPublic={false} />
        <DropArea />
      </Content>
      <Toast />
      <Prompt formComponent={Form} />
      <Memory />
      <Resolution />
      {SHOW_ANALYTICS_LOG && <AnalyticsLog />}
    </Wrapper>
  );
};
